// extracted by mini-css-extract-plugin
export default {"row":"TableRow_row__dcavn","text":"TableRow_text__fQZjP","actions":"TableRow_actions__6Zw4t"};